export enum AddressType {
  Billing = 'billing',
  Shipping = 'shipping',
}

export const AddressTypeOptions = [
  {
    value: AddressType.Billing,
    label: 'Cobrança',
  },
  {
    value: AddressType.Shipping,
    label: 'Entrega',
  },
];

export const SUPER_ADMIN = 'super_admin';
export const STORE_OWNER = 'store_owner';
export const STAFF = 'staff';
export const TOKEN = 'token';
export const PERMISSIONS = 'permissions';
export const AUTH_CRED = 'AUTH_CRED_SHOP';
export const EMAIL_VERIFIED = 'emailVerified';
export const MAINTENANCE_DETAILS = 'MAINTENANCE_DETAILS';

export const MIN_PRICE_TO_SHOW_SHIPPING = 40;
export const MIN_DISCOUNT_PERCENTAGE = 5;
